import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;

class ProductService {
  static fetch(originParams) {
    const params = {
      ...{ page_size: 50 },
      ...originParams,
    };
    return request.get(`${apiUrlV1}/merchandise/`, { params });
  }
}

export default ProductService;
